<div class="audio-manager">
  <mat-spinner 
    *ngIf="!ready" 
    diameter="40"
  />

  <!-- Tabella -->
  <div *ngIf="audios.length > 0; else addFirstAudio">
    <h2 >AUDIOS</h2>
    <table class="audio-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Audio</th>
          <th>Title</th>
          <th>Author</th>
          <th>Album</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audio of audios; let i = index">
          <td class="order">
            <span class="num">
              {{ i + 1 }}
            </span>
            <input type="checkbox" name="on" [checked]="audio.on">
          </td>
          <td class="url-cell" title="{{ audio.url }}">{{ audio.url }}</td>
          <td>{{ audio.title }}</td>
          <td>{{ audio.author }}</td>
          <td class="albumImgUrl">
            <img *ngIf="audio.albumImgUrl != ''" [src]="audio.albumImgUrl">
          </td>
          <td>{{ audio.description }}</td>
          <td class="action-buttons">
            <button (click)="editRecord(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="removeRecord(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'up')" [disabled]="i === 0">
              <mat-icon>arrow_upward_alt</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'down')" [disabled]="i === audios.length - 1">
              <mat-icon>arrow_downward_alt</mat-icon>
            </button>
            <button (click)="addRecord(i)">
              <mat-icon>add</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #addFirstAudio>
    <div
      class="add-first-audio"
      (click)="addRecord(-1)"
    >
      ADD AN AUDIO
    </div>
  </ng-template>
  
</div>